function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { useHistory } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { rgba } from "polished";
import { Tooltip } from "react-tippy";
import { Card, MatIcon, TextButton, Skeleton, BlockButton } from "fiver-react-ui-components";
import useStyledTheme from "../hooks/useStyledTheme";
const StyledHeaderRow = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`;
const StyledTitle = styled.div`
  font-family: ${p => p.theme.fontFamilyDefault};
  color: ${p => p.theme.colorLabel};
`;
const StyledStepRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
`;
const StyledStep = styled.div`
  position: relative;
  flex: 0 0 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 22px;
    width: 100%;
    height: 3px;
    background: ${p => p.allValid ? rgba(p.theme.colorSuccess, 0.1) : p.theme.colorBorder};
  }

  &:first-child::after {
    width: 50%;
    left: 50%;
  }

  &:last-child::after {
    width: 50%;
    right: 50%;
  }
`;
const StyledStepInner = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledStepBubble = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-bottom: 0.75rem;
  border-radius: 50%;
  border: 3px solid white;
  font-family: ${p => p.theme.fontFamilyDefault};
  background: ${p => p.isSuccess ? rgba(p.theme.colorSuccess, 0.1) : p.theme.colorLightGrey};

  color: ${p => p.isSuccess ? p.theme.colorSuccess : p.theme.colorLabel};

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: white;
  }
`;
const StyledBubbleBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 2px solid white;
  background: ${p => p.isSuccess ? p.theme.colorSuccess : p.theme.colorDanger};
  color: white;
`;
const StyledStepText = styled.div`
  font-size: 0.675rem;
  font-family: ${p => p.theme.fontFamilyDefault};
  text-align: center;
  color: ${p => p.isSuccess ? p.theme.colorSuccess : p.theme.colorLabel};
`;
const StyledTooltipInner = styled.div`
  width: 160px;
  font-weight: 400;
  font-size: 0.75rem;
  font-family: ${p => p.theme.fontFamilyDefault};
`;
const StyledTooltipButton = styled.button`
  background: ${p => p.theme.colorSuccess};
  color: white;
  border-radius: 0.25rem;
  width: 100%;
  padding: 0.625rem 0;
  font-size: 0.75rem;
  font-family: ${p => p.theme.fontFamilyDefault};
`;

const WalletHelp = ({
  translations,
  addCard,
  onError,
  phoneVerified,
  cardAdded,
  isLoading
}) => {
  const theme = useStyledTheme();
  const history = useHistory();

  const CustomTooltip = ({
    children,
    ...rest
  }) => /*#__PURE__*/React.createElement(Tooltip, _extends({
    trigger: "click",
    interactive: true,
    arrow: true,
    distance: 15
  }, rest), children);

  const TooltipTheme = ({
    children
  }) => /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);

  const PhoneVerifiedTooltip = /*#__PURE__*/React.createElement(TooltipTheme, null, /*#__PURE__*/React.createElement(StyledTooltipInner, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageVerifyPhoneHelp), /*#__PURE__*/React.createElement(StyledTooltipButton, {
    onClick: () => history.push("/confirm-phone")
  }, translations.howToWithdrawStep1)));
  const CardAddedTooltip = /*#__PURE__*/React.createElement(TooltipTheme, null, /*#__PURE__*/React.createElement(StyledTooltipInner, null, /*#__PURE__*/React.createElement("div", null, translations.messageAddCardHelp), /*#__PURE__*/React.createElement(StyledTooltipButton, {
    onClick: () => addCard()
  }, translations.addCard)));
  const TapWithdrawTooltip = /*#__PURE__*/React.createElement(TooltipTheme, null, /*#__PURE__*/React.createElement(StyledTooltipInner, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageTapWithdrawHelp), /*#__PURE__*/React.createElement(StyledTooltipButton, {
    to: "/confirm-phone"
  }, translations.howToWithdrawStep1)));
  const TapWithdrawTooltipValid = /*#__PURE__*/React.createElement(TooltipTheme, null, /*#__PURE__*/React.createElement(StyledTooltipInner, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageTapWithdrawHelp2), /*#__PURE__*/React.createElement(StyledTooltipButton, {
    disabled: true,
    disabledSuccess: true,
    disabledSuccessIcon: "  "
  }, translations.howToWithdrawStep3)));
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(StyledHeaderRow, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledTitle, null, translations.howToWithdraw))), /*#__PURE__*/React.createElement(StyledStepRow, null, /*#__PURE__*/React.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/React.createElement(CustomTooltip, {
    html: PhoneVerifiedTooltip,
    disabled: phoneVerified
  }, /*#__PURE__*/React.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledStepBubble, {
    isSuccess: phoneVerified
  }, "1", /*#__PURE__*/React.createElement(StyledBubbleBadge, {
    isSuccess: phoneVerified
  }, /*#__PURE__*/React.createElement(MatIcon, {
    size: "10px"
  }, phoneVerified ? "check" : "close"))), /*#__PURE__*/React.createElement(StyledStepText, {
    isSuccess: phoneVerified
  }, translations.howToWithdrawStep1))))), /*#__PURE__*/React.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/React.createElement(CustomTooltip, {
    html: CardAddedTooltip,
    disabled: cardAdded || !phoneVerified ? true : false
  }, /*#__PURE__*/React.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledStepBubble, {
    isSuccess: cardAdded ? true : false
  }, "2", /*#__PURE__*/React.createElement(StyledBubbleBadge, {
    isSuccess: cardAdded ? true : false
  }, /*#__PURE__*/React.createElement(MatIcon, {
    size: "10px"
  }, cardAdded ? "check" : "close"))), /*#__PURE__*/React.createElement(StyledStepText, {
    isSuccess: cardAdded ? true : false
  }, translations.howToWithdrawStep2))))), /*#__PURE__*/React.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/React.createElement(CustomTooltip, {
    disabled: cardAdded && phoneVerified,
    html: cardAdded && phoneVerified ? TapWithdrawTooltipValid : null
  }, /*#__PURE__*/React.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledStepBubble, {
    isSuccess: cardAdded && phoneVerified ? true : false
  }, "3", /*#__PURE__*/React.createElement(StyledBubbleBadge, {
    isSuccess: cardAdded && phoneVerified ? true : false
  }, /*#__PURE__*/React.createElement(MatIcon, {
    size: "10px"
  }, cardAdded && phoneVerified ? "check" : "close"))), /*#__PURE__*/React.createElement(StyledStepText, {
    isSuccess: cardAdded && phoneVerified
  }, translations.howToWithdrawStep3)))))));
};

export default WalletHelp;